import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen bg-sand-50">
      {/* Left side - Form */}
      <div className="flex w-full flex-col justify-center px-4 py-12 sm:px-6 lg:w-1/2 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:max-w-md">
          {/* Logo */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-earth-700 font-display">
              Beyond Class
            </h1>
            <p className="mt-1 text-earth-700">Student Portal</p>
          </div>

          {children}
        </div>
      </div>

      {/* Right side - Travel Image */}
      <div className="relative hidden w-1/2 lg:block">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1488085061387-422e29b40080?q=80&w=2831&auto=format&fit=crop')`,
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-earth-900/70 via-earth-800/60 to-olive-900/70" />

          {/* Content */}
          <div className="relative flex h-full flex-col items-center justify-center p-12 text-white">
            <div className="max-w-md text-center">
              {/* Travel Icon */}
              <div className="mb-6 flex justify-center">
                <div className="w-16 h-16 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <i className="ri-plane-line text-3xl text-white"></i>
                </div>
              </div>

              <h2 className="text-4xl font-bold font-display mb-4">
                Learn English for your next adventures
              </h2>
              <p className="text-lg text-white/80">
                Track your progress, access exclusive materials, and schedule
                your private lessons with ease.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
